export default __webpack_public_path__ + "static/media/preferredHeader.5aea47bb.svg";